import React from 'react';
import { Container } from '@adobe/cq-react-editable-components';
import { Row, Col } from '../../common/Grid';
import { FWAContainer } from '../../common/FWAContainer';
import Header from './Components/Header';
import { renderHTML, fccConstantValues, setCookie } from '../../common/Helpers';
import AddressSearchComponent from './addressSearch';
import { ExternalHeaderAndFooterIntegration } from './headerFooter';
import Notification from '../../common/Notification/redesign/index';
import { commonErrors } from '../../common/Helpers/constants';
import { setCookieDetails, enableBroadBandFacts, getSelectedAddress, getFCCCookies, setCookieFromURL } from './constant';
import { LanguageLink } from './spanishLink';

export default class AddressSearch extends Container {
  constructor(props) {
    super(props);
    enableBroadBandFacts();
    const { location } = this.props;
    if (location?.pathname?.includes('ext-addressSearch')) {
      setCookieDetails(fccConstantValues?.cookieValue?.Unlimited, '', fccConstantValues?.NationalRetailerFlow);
    } else if (window.location.href.toLowerCase().includes('ult')) {
      setCookieDetails(fccConstantValues?.cookieValue?.Unlimited, '', fccConstantValues?.learnPageFlow);
    }
    const { site, category } = getFCCCookies();
    if (!site && !category) {
      setCookieFromURL();
    }
    if (site !== '' && category !== '') {
      setCookie('fcc', false);
    }
    ExternalHeaderAndFooterIntegration();
    this.state = {
      streetAddress: getSelectedAddress()?.entireStreetAddress || '',
    };
  }

  onChangeStreetAddress = (value) => {
    this.setState({ streetAddress: value });
  };

  componentDidMount() {
    this.props.invokeTaggingAPI();
    document.title = 'Address Search';
    const { storeUserSelectedAddress } = this.props;
    if (this.props?.location.search.includes('planid')) {
      const PlanId = this.props?.location?.search?.split('=')[1];
      this.props.setPlanIdFilter(PlanId);
      setCookie('FilterPlan', PlanId);
    }
    const addressSelect = getSelectedAddress();
    if (addressSelect?.entireStreetAddress) {
      console.log(addressSelect?.entireStreetAddress, 'testaddress2');
      storeUserSelectedAddress(addressSelect?.entireStreetAddress);
    }
  }

  render() {
    const notificationProps = {
      renderIf: false,
      title: '',
      type: 'warning',
    };

    if (this.props?.errorMessage?.value) {
      notificationProps.renderIf = this.props?.errorMessage?.value || true;
      notificationProps.title = renderHTML(this.props?.errorMessage?.errorText || commonErrors?.defaultMessage);
    }

    return (
      <div>
        <FWAContainer>
          <Notification {...notificationProps} />
          <Row className="marginTop15 marginBottom10 justfy-end">
            <Col>
              <LanguageLink />
            </Col>
          </Row>
          <Row>
            <Header />
          </Row>
          <AddressSearchComponent streetAddress={this.state.streetAddress} onChangeStreetAddress={this.onChangeStreetAddress} {...this.props} />
        </FWAContainer>
      </div>
    );
  }
}
